import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RealtyImage } from 'shared/api/kyrgyzstan/search'
import { AppAdviceText } from 'shared/ui/app-advice-text'
import { GalleryGrid } from 'shared/ui/gallery-grid'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Loader } from 'shared/ui/loader'

import s from './styles.module.scss'

interface GalleryWrapperProps {
  images: RealtyImage[]
  title: string
  isLoading: boolean
  error: string | null
  onImageClick: (index: number) => void
}

export const GalleryWrapper = ({
  images,
  title,
  isLoading,
  error,
  onImageClick,
}: GalleryWrapperProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate(-1)
  }

  if (isLoading) {
    return (
      <div className="container">
        <HeaderGoBack
          title=""
          onGoBack={handleGoBack}
          variant="grey"
          buttonWhite
        />

        <div className={s.loader}>
          <Loader />
          <AppAdviceText />
        </div>
      </div>
    )
  }

  if (error || !images || images.length === 0) {
    return (
      <div className="container">
        <HeaderGoBack
          title=""
          onGoBack={handleGoBack}
          variant="grey"
          buttonWhite
        />
        <div className={s.error}>
          <p>{error || t('kyrgyzstan_block.error.title')}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      <HeaderGoBack
        title={title}
        onGoBack={handleGoBack}
        variant="grey"
        buttonWhite
      />

      <GalleryGrid
        images={images}
        onImageClick={onImageClick}
      />
    </div>
  )
}
